function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { schema, MarkdownParser, MarkdownSerializer } from 'prosemirror-markdown';
import { Schema } from 'prosemirror-model';

var mentionParser = function mentionParser() {
  return {
    node: 'mention',
    getAttrs: function getAttrs(_ref) {
      var mention = _ref.mention;
      var userId = mention.userId,
          userFullName = mention.userFullName;
      return {
        userId: userId,
        userFullName: userFullName
      };
    }
  };
};

var markdownSerializer = function markdownSerializer() {
  return function (state, node) {
    var uri = state.esc("mention://user/".concat(node.attrs.userId, "/").concat(encodeURIComponent(node.attrs.userFullName)));
    var escapedDisplayName = state.esc('@' + (node.attrs.userFullName || ''));
    state.write("[".concat(escapedDisplayName, "](").concat(uri, ")"));
  };
};

export var addMentionsToMarkdownSerializer = function addMentionsToMarkdownSerializer(serializer) {
  return new MarkdownSerializer(_objectSpread({
    mention: markdownSerializer()
  }, serializer.nodes), serializer.marks);
};
var mentionNode = {
  attrs: {
    userFullName: {
      default: ''
    },
    userId: {
      default: ''
    }
  },
  group: 'inline',
  inline: true,
  selectable: true,
  draggable: true,
  atom: true,
  toDOM: function toDOM(node) {
    return ['span', {
      class: 'prosemirror-mention-node',
      'mention-user-id': node.attrs.userId,
      'mention-user-full-name': node.attrs.userFullName
    }, "@".concat(node.attrs.userFullName)];
  },
  parseDOM: [{
    tag: 'span[mention-user-id][mention-user-full-name]',
    getAttrs: function getAttrs(dom) {
      var userId = dom.getAttribute('mention-user-id');
      var userFullName = dom.getAttribute('mention-user-full-name');
      return {
        userId: userId,
        userFullName: userFullName
      };
    }
  }]
};

var addMentionNodes = function addMentionNodes(nodes) {
  return nodes.append({
    mention: mentionNode
  });
};

export var schemaWithMentions = new Schema({
  nodes: addMentionNodes(schema.spec.nodes),
  marks: schema.spec.marks
});
export var addMentionsToMarkdownParser = function addMentionsToMarkdownParser(parser) {
  return new MarkdownParser(schemaWithMentions, parser.tokenizer, _objectSpread(_objectSpread({}, parser.tokens), {}, {
    mention: mentionParser()
  }));
};